import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { LinkSmall } from '@styled';

const MemberCallToAction = ({ id, graphID, onClick }) => {
    const history = useHistory();

    return (
        <div>
            <LinkSmall
                className="d-inline-block align-middle mr-2"
                href={`/member/profile/${id}`}
                onClick={e => {
                    onClick();

                    // History is undefined if called from within a modal
                    if (!history) {
                        return;
                    }

                    e.preventDefault();
                    history.push(`/member/profile/${id}`, { graphID });
                }}
            >
                View Profile
            </LinkSmall>
        </div>
    );
};

MemberCallToAction.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    graphID: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

export default MemberCallToAction;
